import { IChangePortionPositionState } from './changePortionPositionContext';
import { ChangePortionPositionActionTypes, TChangePortionPositionActions } from './changePortionPositionActions';

export const changePortionPositionReducer = (
	state: IChangePortionPositionState,
	action: TChangePortionPositionActions,
): IChangePortionPositionState => {
	switch (action.type) {
		case ChangePortionPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				selectedRestaurant: null,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangePortionPositionActionTypes.SET_RESTAURANT:
			return {
				...state,
				selectedRestaurant: action.payload.selectedRestaurant,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangePortionPositionActionTypes.SET_ID_DISH:
			return {
				...state,
				IDSelectedDish: action.payload.IDSelectedDish,
				positionsData: [],
			};
		case ChangePortionPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				selectedRestaurant: null,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangePortionPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangePortionPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ChangePortionPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisibleAdditionalRestaurantsModal,
				isApplyToOne: action.payload.isApplyToOne,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
				selectSearchString: action.payload.selectSearchString,
			};
		case ChangePortionPositionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case ChangePortionPositionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case ChangePortionPositionActionTypes.CHANGE_SELECT_SEARCH_STRING:
			return {
				...state,
				selectSearchString: action.payload.selectSearchString,
			};
		default:
			return state;
	}
};
